module.exports = __webpack_public_path__ + "img/68.432e8c2f.png";